export default "__VITE_ASSET__3e182753__"